<script lang="ts" setup>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

interface Props {
  open: boolean
  redirectVal?: string
}

const props = defineProps<Props>()
const emit = defineEmits(['openModal', 'otpComplete'])
const config = useRuntimeConfig()
const isOpen = computed(() => props.open)
const showBox = ref(true)
</script>

<template>
  <div>
    <TransitionRoot appear :show="isOpen" as="template">
      <Dialog as="div" class="relative z-100" :static="true">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <div class="fixed inset-0 bg-black bg-opacity-25" style="backdrop-filter: blur(10px)" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <DialogPanel :class="`${showBox ? '' : 'hidden'} w-full max-w-md min-h-md p-6 transform overflow-hidden rounded-md bg-white align-middle shadow-xl transition-all`">
                <Icon name="heroicons:x-mark" class="w-5 h-5 cursor-pointer absolute right-6" @click="emit('openModal', false)" />
                <ContinueForm :redirect-val="props.redirectVal" class="text-gray-900 w-full max-w-md grid" @show-box="(data: boolean) => showBox = data" />
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
